import { FeedbackNudge } from "@/components/feedback/FeedbackNudge";
import { Toaster } from "@/components/ui/sonner";
import { activateLocale, i18n } from "@/i18n";
import { I18nProvider } from "@lingui/react";
import { PostHogProvider } from "@posthog/react";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { PostHogPageviews } from "./components/analytics/PostHogPageviews";
import { PageViewTracker } from "./components/routing/PageViewTracker";
import { getInitialLocale } from "./i18n/initialLocale";
import "./index.css";
import { AuthBridge } from "./lib/AuthBridge";
import { initPostHog, posthog } from "./lib/posthog";
import { queryClient } from "./lib/queryClient";
import { initSentry, Sentry } from "./lib/sentry";
import { setupAppSW } from "./sw/registerSW";
import { isBrowser } from "./utils/is-browser.utils";

async function bootstrap() {
  if (isBrowser && !import.meta.env.SSR) {
    initSentry();
    initPostHog();
    setupAppSW();
  }

  const locale = getInitialLocale();
  await activateLocale(locale);

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <QueryClientProvider client={queryClient}>
          <AuthBridge>
            <BrowserRouter>
              <I18nProvider i18n={i18n}>
                <Sentry.ErrorBoundary
                  fallback={
                    <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
                      Something went wrong.
                    </div>
                  }
                >
                  <App />
                </Sentry.ErrorBoundary>
                <Toaster />
                <PostHogPageviews />
                <FeedbackNudge />
                <PageViewTracker />
              </I18nProvider>
            </BrowserRouter>
          </AuthBridge>
        </QueryClientProvider>
      </PostHogProvider>
    </React.StrictMode>,
  );
}

bootstrap();
